import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { SERVICE_OPTIONS } from "@/lib/site";

const optionTestId = (option) =>
  `service-option-${option
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")}`;

const FieldError = ({ id, message }) =>
  message ? (
    <p id={id} className="text-xs text-red-600">
      {message}
    </p>
  ) : null;

const RequiredMark = () => <span className="text-[#f28a2e]">*</span>;

export const TextField = ({
  id,
  label,
  value,
  onChange,
  error,
  testId,
  placeholder,
  type = "text",
  required = false,
}) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-[#0b1d3a]">
      {label} {required ? <RequiredMark /> : null}
    </Label>
    <Input
      id={id}
      name={id}
      type={type}
      data-testid={testId}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      aria-invalid={Boolean(error)}
      aria-describedby={error ? `${id}-error` : undefined}
    />
    <FieldError id={`${id}-error`} message={error} />
  </div>
);

export const MessageField = ({ value, onChange, error }) => (
  <div className="space-y-1.5">
    <Label htmlFor="message" className="text-[#0b1d3a]">
      Your message <RequiredMark />
    </Label>
    <Textarea
      id="message"
      name="message"
      rows={3}
      data-testid="contact-form-message-textarea"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Tell us who you are and what you would like to discuss."
      aria-invalid={Boolean(error)}
      aria-describedby={error ? "message-error" : undefined}
    />
    <FieldError id="message-error" message={error} />
  </div>
);

export const EnquiryTypeField = ({ value, onChange, error }) => (
  <div className="space-y-1.5">
    <Label htmlFor="service" className="text-[#0b1d3a]">
      Enquiry type <RequiredMark />
    </Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        id="service"
        data-testid="contact-form-service-select"
        aria-invalid={Boolean(error)}
      >
        <SelectValue placeholder="Choose an enquiry type" />
      </SelectTrigger>
      <SelectContent className="bg-white">
        {SERVICE_OPTIONS.map((option) => (
          <SelectItem key={option} value={option} data-testid={optionTestId(option)}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
    <FieldError message={error} />
  </div>
);

/** Hidden field that only bots fill in. */
export const HoneypotField = ({ value, onChange }) => (
  <div className="hidden" aria-hidden="true">
    <label htmlFor="company_website">Company website</label>
    <input
      id="company_website"
      name="company_website"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
  </div>
);
